import React from 'react';
import style from './pageHeader.module.scss';
import classNames from 'classnames';

export enum HeaderSplashImage {
    Airplane,
    People
}

interface PageHeaderOwnProps {
    title: JSX.Element;
    splashImage?: HeaderSplashImage;
}

export class PageHeader extends React.Component<PageHeaderOwnProps, {}> {
    render(): JSX.Element {
        const image = this.props.splashImage || HeaderSplashImage.Airplane;
        const imageClass = image === HeaderSplashImage.Airplane ? style.Airplane : style.People;
        return (
            <div className={style.PageHeader}>
                <div className={classNames(style.Image, imageClass)} />
                <h1 className={style.Title}>
                    <span className={style.Inner}>
                        {this.props.title}
                    </span>
                </h1>
            </div>
        );
    }
}
